<main class="wrapper">
  <app-splash-screen [@inOutAnimation] *ngIf="isSplashScreenActive"></app-splash-screen>
  <app-welcome [@inOutAnimation] *ngIf="isWelcomeScreenActive" (onNextClickEvent)="onWelcomeScreenClick()"></app-welcome>
  <app-payment-check [@inOutAnimation] *ngIf="isPaymentCheckScreenActive"></app-payment-check>
  <app-deceased-person [@inOutAnimation] *ngIf="isDeceasedPersonScreenActive" (onSkip)="onDeathPersonSkip()" (onBack)="onBack()">
  </app-deceased-person>
  <app-close [@inOutAnimation] *ngIf="isCloseScreenActive"></app-close>
</main>
